import { jsx } from 'react/jsx-runtime';
import { memo, useMemo } from 'react';
import PropTypes from 'prop-types';
import { ScheduleContext } from './contexts.js';

function LiveInfoProvider({
  schedule: { startTime, endTime } = {},
  children = void 0
}) {
  const schedule = useMemo(() => ({
    startTime: new Date(startTime),
    endTime: new Date(endTime)
  }), [startTime, endTime]);
  return /* @__PURE__ */ jsx(ScheduleContext.Provider, { value: schedule, children });
}
LiveInfoProvider.propTypes = {
  schedule: PropTypes.shape({
    startTime: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string,
      PropTypes.instanceOf(Date)
    ]),
    endTime: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string,
      PropTypes.instanceOf(Date)
    ])
  }),
  children: PropTypes.node
};
var LiveInfoProvider$1 = memo(LiveInfoProvider);

export { LiveInfoProvider$1 as default };
//# sourceMappingURL=LiveInfoProvider.js.map
